import { SearchItem } from "./SearchItem";

/**
 * Normalized product result for UI consumption
 * Contains only product-specific fields, no Meilisearch-specific structure
 */
export interface ProductResult extends SearchItem {
  type: "product";
  /** Product image URL */
  image?: string;
  /** Display price (formatted string) */
  price?: string;
  /** Product detail page URL */
  url?: string;
  /** Количество дополнительных вариантов товара (для отображения бейджа) */
  variantsCount?: number;
  available?: boolean;
  oldPrice?: number | null;
  numericPrice?: number;
}

/**
 * Type guard to check if an object is a ProductResult
 */
export function isProductResult(obj: unknown): obj is ProductResult {
  if (!obj || typeof obj !== "object") return false;

  const product = obj as Record<string, unknown>;
  return (
    product.type === "product" &&
    typeof product.id !== "undefined" &&
    typeof product.title === "string" &&
    product.raw !== undefined
  );
}
